import { createContext, useContext, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchBrightSkyWeather, fetchBrightSkyForecast } from '../services/ioBroker'

const WeatherContext = createContext(null)

export function useWeather() {
  return useContext(WeatherContext)
}

export function WeatherProvider({ children }) {
  const brightskyQ = useQuery({ queryKey: ['brightsky'], queryFn: fetchBrightSkyWeather, refetchInterval: 300_000 })
  const forecastQ  = useQuery({ queryKey: ['forecast'],  queryFn: fetchBrightSkyForecast, refetchInterval: 300_000 })

  const value = useMemo(() => ({
    brightsky: brightskyQ.data ?? null,
    forecast:  forecastQ.data  ?? [],
    error:     brightskyQ.isError,
  }), [brightskyQ.data, forecastQ.data, brightskyQ.isError])

  return <WeatherContext.Provider value={value}>{children}</WeatherContext.Provider>
}
